import { render, staticRenderFns } from "./add-company.vue?vue&type=template&id=b5a55f4e&scoped=true"
import script from "./add-company.vue?vue&type=script&lang=js"
export * from "./add-company.vue?vue&type=script&lang=js"
import style0 from "./add-company.vue?vue&type=style&index=0&id=b5a55f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a55f4e",
  null
  
)

export default component.exports